import acura from './acura.svg';
import alfa_romeo from './alfa-romeo.svg';
import aston_martin from './aston-martin.svg';
import audi from './audi.svg';
import bmw from './bmw.svg';
import buick from './buick.svg';
import cadillac from './cadillac.svg';
import chevrolet from './chevrolet.svg';
import chrysler from './chrysler.svg';
import dodge from './dodge.svg';
import fiat from './fiat.svg';
import ford from './ford.svg';
import gmc from './gmc.svg';
import honda from './honda.svg';
import hondacanada from './hondacanada.svg';
import hyundai from './hyundai.svg';
import infiniti from './infiniti.svg';
import jaguar from './jaguar.svg';
import jeep from './jeep.svg';
import kia from './kia.svg';
import land_rover from './land-rover.svg';
import lexus from './lexus.svg';
import lincoln from './lincoln.svg';
import mazda from './mazda.svg';
import mercedes_benz from './mercedes-benz.svg';
import mini from './mini.svg';
import mitsubishi from './mitsubishi.svg';
import porsche from './porsche.svg';
import ram from './ram.svg';
import subaru from './subaru.svg';
import tesla from './tesla.svg';
import toyota from './toyota.svg';
import volkswagen from './volkswagen.svg';
import volvo from './volvo.svg';

export const images = {
    acura,
    alfa_romeo,
    aston_martin,
    audi,
    bmw,
    buick,
    cadillac,
    chevrolet,
    chrysler,
    dodge,
    fiat,
    ford,
    gmc,
    honda,
    hondacanada,
    hyundai,
    infiniti,
    jaguar,
    jeep,
    kia,
    land_rover,
    lexus,
    lincoln,
    mazda,
    mercedes_benz,
    mini,
    mitsubishi,
    porsche,
    ram,
    subaru,
    tesla,
    toyota,
    volkswagen,
    volvo,
};
